import { useContext } from "react";
import {
  GeneralConfigurationContext,
  ModalItemContext,
} from "features/configuration/GeneralConfiguration/generalConfigurationContexts";
import {
  getChildren,
  getFieldType,
  itemShouldOpenModal,
} from "features/configuration/GeneralConfiguration/utils";
import {
  CHECKBOX_FIELD_TYPE_STRING,
  COMBINED_FIELD_TYPE_STRING,
  DATA_RADIO_FIELD_TYPE_STRING,
  PRICE_RANGE_FIELD_TYPE_STRING,
  RADIO_FIELD_TYPE_STRING,
  STRATEGY_FIELD_TYPE_STRING,
  TEXTBOX_FIELD_TYPE_STRING,
  WHEEL_FIELD_TYPE_STRING,
} from "features/configuration/common/constants";
import CombinedItem from "features/configuration/GeneralConfiguration/ConfigurationItem/CombinedItem";
import WheelItem from "features/configuration/GeneralConfiguration/ConfigurationItem/WheelItem";
import TextBoxItem from "features/configuration/GeneralConfiguration/ConfigurationItem/TextBoxItem";
import CheckboxItem from "features/configuration/GeneralConfiguration/ConfigurationItem/CheckboxItem";
import ModalItem from "features/configuration/GeneralConfiguration/ConfigurationItem/ModalItem";
import HeaderItem from "features/configuration/GeneralConfiguration/ConfigurationItem/HeaderItem";
import StrategyItem from "features/configuration/GeneralConfiguration/ConfigurationItem/StrategyItem";
import DataRadioItem from "features/configuration/GeneralConfiguration/ConfigurationItem/DataRadioItem";
import PriceRangeItem from "features/configuration/GeneralConfiguration/ConfigurationItem/PriceRangeItem";
import { getIsSectionHeader } from "@shared/features/configuration/utils";

const ConfigurationItem = ({ item, ...props }: any) => {
  const { idToItem } = useContext(GeneralConfigurationContext)!;
  const { inModal } = useContext(ModalItemContext)!;
  const isSectionHeader = getIsSectionHeader(item);
  const fieldType = getFieldType(item, idToItem);
  const isModalItem = itemShouldOpenModal(item);
  const children = getChildren(item);

  if (isSectionHeader) {
    return <HeaderItem item={item} {...props} />;
  } else if (
    isModalItem &&
    !inModal &&
    fieldType !== CHECKBOX_FIELD_TYPE_STRING
  ) {
    return <ModalItem item={item} {...props} />;
  }

  if (fieldType === COMBINED_FIELD_TYPE_STRING) {
    return <CombinedItem item={item} {...props} />;
  } else if (
    [RADIO_FIELD_TYPE_STRING, WHEEL_FIELD_TYPE_STRING].indexOf(fieldType) >= 0
  ) {
    return <WheelItem item={item} {...props} />;
  } else if (fieldType === TEXTBOX_FIELD_TYPE_STRING) {
    return <TextBoxItem item={item} {...props} />;
  } else if (fieldType === CHECKBOX_FIELD_TYPE_STRING) {
    return <CheckboxItem item={item} {...props} />;
  } else if (fieldType === STRATEGY_FIELD_TYPE_STRING) {
    return <StrategyItem item={item} {...props} />;
  } else if (fieldType === DATA_RADIO_FIELD_TYPE_STRING) {
    return <DataRadioItem item={item} {...props} />;
  } else if (fieldType === PRICE_RANGE_FIELD_TYPE_STRING) {
    return <PriceRangeItem item={item} {...props} />;
  }

  return children.map((child, index) => (
    <ConfigurationItem key={index} item={child} {...props} />
  ));
};

export default ConfigurationItem;
